import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Typography
} from "@mui/material";
import localStrings from "../localStrings";

const NoCredit = () => (
  <>
    <Helmet>
      <title>404 | Material Kit</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <Typography
          align="center"
          color="textPrimary"
          variant="h2"
        >
          {localStrings.noCreditMessageOne}
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt="Under development"
            src="/static/images/undraw_savings_re_eq4w.svg"
            style={{
              marginTop: 50,
              display: 'inline-block',
              maxWidth: '100%',
              width: 450
            }}
          />
        </Box>
      </Container>
    </Box>
  </>
);

export default NoCredit;
